<template>
    <h1
        v-if="isShowCategoryTitle"
        class="page-title"
    >
        {{ categoryTitle }}
    </h1>
    <ul class="faq__list-wrapper">
        <li
            v-for="(childNode, index) in nodeData.children"
            :key="index"
            class="faq__list-item"
        >
            <router-link
                :to="childNode.fullPath"
            >
                {{ childNode.attributes.title }}
            </router-link>
        </li>
    </ul>
</template>

<script>

export default {
    name: 'FAQCategory',
    props: {
        nodeData: {
            type: Object,
            required: true,
        },
    },
    computed: {
        isShowCategoryTitle() {
            return !this.nodeData.isRoot
        },
        categoryTitle() {
            return this.nodeData.attributes.title;
        },
    },
}
</script>
